import { useEffect } from 'react';

import { Message } from '@components/atoms';

type TUseCatchHttpError = {
  errorMessage: any;
  isAutoCatchingError: boolean;
};

function useCatcHttpError({ errorMessage, isAutoCatchingError }: TUseCatchHttpError) {
  useEffect(() => {
    if (errorMessage && isAutoCatchingError) {
      Message.error(errorMessage);
    }
  }, [errorMessage]);
}

export default useCatcHttpError;
